import {
  Component,
  ContentChildren,
  QueryList,
  AfterContentInit,
  HostBinding,
  Input,
} from '@angular/core';

import { TabItem } from './tab-item.component';

@Component({
  selector: 'suka-tabs',
  template: `
    <ul class="tabs">
      <li
        *ngFor="let tab of tabs"
        (click)="selectTab(tab)"
        [class.tabs__tab-container--selected]="tab.active"
        class="tabs__tab-container"
      >
        <button class="tabs__tab" type="button" role="tab">
          <span class="tabs__title">{{tab.title}}</span>
        </button>
      </li>
    </ul>
    <ng-content></ng-content>
  `,
})
export class Tabs implements AfterContentInit {
  @HostBinding('class.tabs-fitted') @Input() fitted = false;

  @ContentChildren(TabItem) tabs: QueryList<TabItem>;

  ngAfterContentInit() {
    const activeTabs = this.tabs.filter((tab) => tab.active);

    if (activeTabs.length === 0) {
      this.selectTab(this.tabs.first);
    }
  }

  selectTab(tabItem: TabItem) {
    this.tabs.toArray().forEach(tab => tab.active = false);

    tabItem.active = true;
    tabItem.ngOnChanges();
  }
}
